import { z } from "zod";

export const groupSchema = z.object({
  sharing: z.object({
    completions: z.boolean(),
    reflections: z.boolean(),
    moodchecks: z.boolean(),
    intentions: z.boolean(),
  }),
  features: z.object({
    invites: z.boolean().optional(),
    replies: z.boolean().optional(),
    reactions: z.boolean(),
    intentions: z.boolean().optional(),
    reflections: z.boolean().optional(),
    moodchecks: z.boolean().optional(),
    messages: z.boolean().optional(),
    completions: z.boolean().optional(),
  }),
  users: z.object({
    id: z.number(),
    name: z.string().nullable(),
    last_name: z.string().nullable(),
    is_leader: z.boolean(),
    image_url: z.string(),
    has_password: z.boolean(),
  }),
});
